import { useContext } from "react";
import { MasterDataContext } from "./MasterDataContext";

export const useMasterData = () => {
    return useContext(MasterDataContext);
};